import { reflexProvocation } from "@karrtopelka/cards/provocations";
import type { CardProps } from "@karrtopelka/cards/types";
import type { SubmitResult } from "@karrtopelka/game-kit";

/** Below this many total scores, the "top X%" line is noise — omit it. */
const RANKLINE_MIN_TOTAL = 10;

export function buildReflexCard(
  bestMs: number,
  handle: string,
  submit: SubmitResult | null,
): CardProps {
  const display = `${bestMs}ms`;
  const props: CardProps = {
    game: "reflex",
    display,
    handle,
    provocation: reflexProvocation(display, bestMs),
    date: new Date().toISOString().slice(0, 10), // YYYY-MM-DD, locale-stable
  };
  // Only brag a percentile once the board has enough volume to mean something.
  if (submit && submit.total >= RANKLINE_MIN_TOTAL) {
    return { ...props, rankLine: `top ${submit.percentile}% today` };
  }
  return props;
}
